import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { adminApi } from "@/lib/api";

const AdminAuthCtx = createContext(null);

export function AdminAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const check = useCallback(async () => {
    const t = localStorage.getItem("rotta_admin_token");
    if (!t) { setUser(false); setLoading(false); return; }
    try {
      const { data } = await adminApi.get("/admin/auth/me");
      setUser(data);
    } catch {
      setUser(false);
      localStorage.removeItem("rotta_admin_token");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { check(); }, [check]);

  const login = async (email, password) => {
    const { data } = await adminApi.post("/admin/auth/login", { email, password });
    localStorage.setItem("rotta_admin_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("rotta_admin_token");
    setUser(false);
    window.location.href = "/admin/login";
  };

  return (
    <AdminAuthCtx.Provider value={{ user, loading, login, logout }}>
      {children}
    </AdminAuthCtx.Provider>
  );
}

export const useAdminAuth = () => useContext(AdminAuthCtx);
